export var areaCodeResp = {
  common: [{
    telephoneCode: '86',
    areaName: '中国',
    currency: '¥'
  }, {
    telephoneCode: '886',
    areaName: '中国台湾',
    currency: 'NT$'
  }, {
    telephoneCode: '852',
    areaName: '中国香港',
    currency: 'HK$'
  }, {
    telephoneCode: '853',
    areaName: '中国澳门',
    currency: 'MOP$'
  }],
  all: [{
    telephoneCode: '60',
    areaName: '马来西亚'
  }, {
    telephoneCode: '62',
    areaName: '印度尼西亚'
  }, {
    telephoneCode: '63',
    areaName: '菲律宾'
  }, {
    telephoneCode: '65',
    areaName: '新加坡',
    currency: 'S$'
  }, {
    telephoneCode: '66',
    areaName: '泰国'
  }, {
    telephoneCode: '673',
    areaName: '文莱'
  }, {
    telephoneCode: '81',
    areaName: '日本',
    currency: '¥'
  }, {
    telephoneCode: '82',
    areaName: '韩国',
    currency: '₩'
  }, {
    telephoneCode: '84',
    areaName: '越南'
  }, {
    telephoneCode: '850',
    areaName: '朝鲜'
  }, {
    telephoneCode: '852',
    areaName: '中国香港',
    currency: 'HK$'
  }, {
    telephoneCode: '853',
    areaName: '中国澳门',
    currency: 'MOP$'
  }, {
    telephoneCode: '855',
    areaName: '柬埔寨'
  }, {
    telephoneCode: '856',
    areaName: '老挝'
  }, {
    telephoneCode: '86',
    areaName: '中国',
    currency: '¥'
  }, {
    telephoneCode: '886',
    areaName: '中国台湾',
    currency: 'NT$'
  }, {
    telephoneCode: '880',
    areaName: '孟加拉国'
  }, {
    telephoneCode: '90',
    areaName: '土耳其'
  }, {
    telephoneCode: '91',
    areaName: '印度'
  }, {
    telephoneCode: '92',
    areaName: '巴基斯坦'
  }, {
    telephoneCode: '93',
    areaName: '阿富汗'
  }, {
    telephoneCode: '94',
    areaName: '斯里兰卡'
  }, {
    telephoneCode: '95',
    areaName: '缅甸'
  }, {
    telephoneCode: '960',
    areaName: '马尔代夫'
  }, {
    telephoneCode: '961',
    areaName: '黎巴嫩'
  }, {
    telephoneCode: '962',
    areaName: '约旦'
  }, {
    telephoneCode: '963',
    areaName: '叙利亚'
  }, {
    telephoneCode: '964',
    areaName: '伊拉克'
  }, {
    telephoneCode: '965',
    areaName: '科威特'
  }, {
    telephoneCode: '966',
    areaName: '沙特阿拉伯'
  }, {
    telephoneCode: '968',
    areaName: '阿曼'
  }, {
    telephoneCode: '972',
    areaName: '以色列'
  }, {
    telephoneCode: '973',
    areaName: '巴林'
  }, {
    telephoneCode: '974',
    areaName: '卡塔尔'
  }, {
    telephoneCode: '975',
    areaName: '不丹'
  }, {
    telephoneCode: '976',
    areaName: '蒙古'
  }, {
    telephoneCode: '977',
    areaName: '尼泊尔'
  }, {
    telephoneCode: '98',
    areaName: '伊朗'
  }, {
    telephoneCode: '7',
    areaName: '俄罗斯'
  }, {
    telephoneCode: '30',
    areaName: '希腊'
  }, {
    telephoneCode: '31',
    areaName: '荷兰'
  }, {
    telephoneCode: '32',
    areaName: '比利时'
  }, {
    telephoneCode: '33',
    areaName: '法国'
  }, {
    telephoneCode: '34',
    areaName: '西班牙'
  }, {
    telephoneCode: '350',
    areaName: '直布罗陀'
  }, {
    telephoneCode: '351',
    areaName: '葡萄牙'
  }, {
    telephoneCode: '352',
    areaName: '卢森堡'
  }, {
    telephoneCode: '353',
    areaName: '爱尔兰'
  }, {
    telephoneCode: '354',
    areaName: '冰岛'
  }, {
    telephoneCode: '355',
    areaName: '阿尔巴尼亚'
  }, {
    telephoneCode: '356',
    areaName: '马耳他'
  }, {
    telephoneCode: '357',
    areaName: '塞浦路斯'
  }, {
    telephoneCode: '358',
    areaName: '芬兰'
  }, {
    telephoneCode: '359',
    areaName: '保加利亚'
  }, {
    telephoneCode: '336',
    areaName: '匈牙利'
  }, {
    telephoneCode: '49',
    areaName: '德国'
  }, {
    telephoneCode: '338',
    areaName: '南斯拉夫'
  }, {
    telephoneCode: '39',
    areaName: '意大利'
  }, {
    telephoneCode: '223',
    areaName: '圣马力诺'
  }, {
    telephoneCode: '396',
    areaName: '梵蒂冈'
  }, {
    telephoneCode: '40',
    areaName: '罗马尼亚'
  }, {
    telephoneCode: '41',
    areaName: '瑞士'
  }, {
    telephoneCode: '4175',
    areaName: '列支敦士登'
  }, {
    telephoneCode: '43',
    areaName: '奥地利'
  }, {
    telephoneCode: '44',
    areaName: '英国'
  }, {
    telephoneCode: '45',
    areaName: '丹麦'
  }, {
    telephoneCode: '46',
    areaName: '瑞典'
  }, {
    telephoneCode: '47',
    areaName: '挪威'
  }, {
    telephoneCode: '48',
    areaName: '波兰'
  }, {
    telephoneCode: '203',
    areaName: '埃及'
  }, {
    telephoneCode: '2103',
    areaName: '摩洛哥'
  }, {
    telephoneCode: '2133',
    areaName: '阿尔及利亚'
  }, {
    telephoneCode: '2163',
    areaName: '突尼斯'
  }, {
    telephoneCode: '2183',
    areaName: '利比亚'
  }, {
    telephoneCode: '2203',
    areaName: '冈比亚'
  }, {
    telephoneCode: '2213',
    areaName: '塞内加尔'
  }, {
    telephoneCode: '2223',
    areaName: '毛里塔尼亚'
  }, {
    telephoneCode: '2233',
    areaName: '马里'
  }, {
    telephoneCode: '2243',
    areaName: '几内亚'
  }, {
    telephoneCode: '2253',
    areaName: '科特迪瓦'
  }, {
    telephoneCode: '2263',
    areaName: '布基拉法索'
  }, {
    telephoneCode: '2273',
    areaName: '尼日尔'
  }, {
    telephoneCode: '2283',
    areaName: '多哥'
  }, {
    telephoneCode: '2293',
    areaName: '贝宁'
  }, {
    telephoneCode: '2303',
    areaName: '毛里求斯'
  }, {
    telephoneCode: '2313',
    areaName: '利比里亚'
  }, {
    telephoneCode: '2323',
    areaName: '塞拉利昂'
  }, {
    telephoneCode: '2333',
    areaName: '加纳'
  }, {
    telephoneCode: '2343',
    areaName: '尼日利亚'
  }, {
    telephoneCode: '2353',
    areaName: '乍得'
  }, {
    telephoneCode: '2363',
    areaName: '中非'
  }, {
    telephoneCode: '2373',
    areaName: '喀麦隆'
  }, {
    telephoneCode: '2383',
    areaName: '佛得角'
  }, {
    telephoneCode: '2393',
    areaName: '圣多美'
  }, {
    telephoneCode: '2393',
    areaName: '普林西比'
  }, {
    telephoneCode: '2403',
    areaName: '赤道几内亚'
  }, {
    telephoneCode: '2413',
    areaName: '加蓬'
  }, {
    telephoneCode: '2423',
    areaName: '刚果'
  }, {
    telephoneCode: '2433',
    areaName: '扎伊尔'
  }, {
    telephoneCode: '2443',
    areaName: '安哥拉'
  }, {
    telephoneCode: '2453',
    areaName: '几内亚比绍'
  }, {
    telephoneCode: '2473',
    areaName: '阿森松'
  }, {
    telephoneCode: '2483',
    areaName: '塞舌尔'
  }, {
    telephoneCode: '2493',
    areaName: '苏丹'
  }, {
    telephoneCode: '2503',
    areaName: '卢旺达'
  }, {
    telephoneCode: '2513',
    areaName: '埃塞俄比亚'
  }, {
    telephoneCode: '2523',
    areaName: '索马里'
  }, {
    telephoneCode: '2533',
    areaName: '吉布提'
  }, {
    telephoneCode: '2543',
    areaName: '肯尼亚'
  }, {
    telephoneCode: '2553',
    areaName: '坦桑尼亚'
  }, {
    telephoneCode: '2563',
    areaName: '乌干达'
  }, {
    telephoneCode: '2573',
    areaName: '布隆迪'
  }, {
    telephoneCode: '2583',
    areaName: '莫桑比克'
  }, {
    telephoneCode: '2603',
    areaName: '赞比亚'
  }, {
    telephoneCode: '2613',
    areaName: '马达加斯加'
  }, {
    telephoneCode: '2623',
    areaName: '留尼旺岛'
  }, {
    telephoneCode: '2633',
    areaName: '津巴布韦'
  }, {
    telephoneCode: '2643',
    areaName: '纳米比亚'
  }, {
    telephoneCode: '2653',
    areaName: '马拉维'
  }, {
    telephoneCode: '2663',
    areaName: '莱索托'
  }, {
    telephoneCode: '2673',
    areaName: '博茨瓦纳'
  }, {
    telephoneCode: '2683',
    areaName: '斯威士兰'
  }, {
    telephoneCode: '2693',
    areaName: '科摩罗'
  }, {
    telephoneCode: '273',
    areaName: '南非'
  }, {
    telephoneCode: '2903',
    areaName: '圣赫勒拿'
  }, {
    telephoneCode: '2973',
    areaName: '阿鲁巴岛'
  }, {
    telephoneCode: '2983',
    areaName: '法罗群岛'
  }, {
    telephoneCode: '1',
    areaName: '美国'
  }, {
    telephoneCode: '1',
    areaName: '加拿大'
  }, {
    telephoneCode: '1808',
    areaName: '中途岛'
  }, {
    telephoneCode: '1808',
    areaName: '夏威夷'
  }, {
    telephoneCode: '1808',
    areaName: '威克岛'
  }, {
    telephoneCode: '1809',
    areaName: '安圭拉岛'
  }, {
    telephoneCode: '1809',
    areaName: '维尔京群岛'
  }, {
    telephoneCode: '1809',
    areaName: '圣卢西亚'
  }, {
    telephoneCode: '1809',
    areaName: '波多黎各'
  }, {
    telephoneCode: '1809',
    areaName: '牙买加'
  }, {
    telephoneCode: '1809',
    areaName: '巴哈马'
  }, {
    telephoneCode: '1809',
    areaName: '巴巴多斯'
  }, {
    telephoneCode: '1907',
    areaName: '阿拉斯加'
  }, {
    telephoneCode: '299',
    areaName: '格陵兰岛'
  }, {
    telephoneCode: '500',
    areaName: '福克兰群岛'
  }, {
    telephoneCode: '501',
    areaName: '伯利兹'
  }, {
    telephoneCode: '502',
    areaName: '危地马拉'
  }, {
    telephoneCode: '503',
    areaName: '萨尔瓦多'
  }, {
    telephoneCode: '504',
    areaName: '洪都拉斯'
  }, {
    telephoneCode: '505',
    areaName: '尼加拉瓜'
  }, {
    telephoneCode: '506',
    areaName: '哥斯达黎加'
  }, {
    telephoneCode: '507',
    areaName: '巴拿马'
  }, {
    telephoneCode: '509',
    areaName: '海地'
  }, {
    telephoneCode: '51',
    areaName: '秘鲁'
  }, {
    telephoneCode: '52',
    areaName: '墨西哥'
  }, {
    telephoneCode: '53',
    areaName: '古巴'
  }, {
    telephoneCode: '54',
    areaName: '阿根廷'
  }, {
    telephoneCode: '55',
    areaName: '巴西'
  }, {
    telephoneCode: '56',
    areaName: '智利'
  }, {
    telephoneCode: '57',
    areaName: '哥伦比亚'
  }, {
    telephoneCode: '58',
    areaName: '委内瑞拉'
  }, {
    telephoneCode: '591',
    areaName: '玻利维亚'
  }, {
    telephoneCode: '592',
    areaName: '圭亚那'
  }, {
    telephoneCode: '593',
    areaName: '厄瓜多尔'
  }, {
    telephoneCode: '594',
    areaName: '法属圭亚那'
  }, {
    telephoneCode: '595',
    areaName: '巴拉圭'
  }, {
    telephoneCode: '596',
    areaName: '马提尼克'
  }, {
    telephoneCode: '597',
    areaName: '苏里南'
  }, {
    telephoneCode: '598',
    areaName: '乌拉圭'
  }, {
    telephoneCode: '61',
    areaName: '大利亚'
  }, {
    telephoneCode: '64',
    areaName: '新西兰'
  }, {
    telephoneCode: '671',
    areaName: '关岛'
  }, {
    telephoneCode: '6722',
    areaName: '科科斯岛'
  }, {
    telephoneCode: '6723',
    areaName: '诺福克岛'
  }, {
    telephoneCode: '6724',
    areaName: '圣诞岛'
  }, {
    telephoneCode: '674',
    areaName: '瑙鲁'
  }, {
    telephoneCode: '676',
    areaName: '汤加'
  }, {
    telephoneCode: '677',
    areaName: '所罗门群岛'
  }, {
    telephoneCode: '678',
    areaName: '瓦努阿图'
  }, {
    telephoneCode: '679',
    areaName: '斐济'
  }, {
    telephoneCode: '682',
    areaName: '科克群岛'
  }, {
    telephoneCode: '683',
    areaName: '纽埃岛'
  }, {
    telephoneCode: '684',
    areaName: '东萨摩亚'
  }, {
    telephoneCode: '685',
    areaName: '西萨摩亚'
  }, {
    telephoneCode: '686',
    areaName: '基里巴斯'
  }, {
    telephoneCode: '688',
    areaName: '图瓦卢'
  }]
};